import { render, staticRenderFns } from "./SampleReceivingLabel.vue?vue&type=template&id=ceacb976"
import script from "./SampleReceivingLabel.vue?vue&type=script&lang=js"
export * from "./SampleReceivingLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports